// Imports


// Plugins
const plugins = [{
  location: "/u/for_penguins/our-assets/equilibrium/node_modules/react-static-plugin-styled-components",
  plugins: [],
  hooks: {}
},
{
  location: "/u/for_penguins/our-assets/equilibrium/node_modules/react-static-plugin-jss",
  plugins: [],
  hooks: {}
},
{
  location: "/u/for_penguins/our-assets/equilibrium",
  plugins: [],
  hooks: {}
}]

// Export em!
export default plugins